/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

export { default as LoginLangDropdown } from './LoginLangDropdown';
